import { useRef } from 'react'
import { MediaModal } from '@/components/pbo/MediaModal'
import { INBOUND_WORK_SEARCH_MENU_CODE } from '@/services/global/inboundWorkSearch/consts'
import InboundWorkSearchPage from './page.generated'
import { closeMedia, resetInboundWorkSearchStore, useMediaState } from './wiring'

/**
 * GL10 입고작업조회 2.0(GL18) — 화면은 컨덕터 생성본(page.generated.tsx), 배선은 wiring.ts (LOGISPRD-16038).
 * 조회 전용이다. 1.0 GL10(iframe)은 그대로 두고 새 메뉴코드로 나란히 올린다.
 * 첨부·동영상은 생성본의 DS 모달(파일 이름만) 대신 공용 MediaModal 을 열람 전용으로 띄운다(RGR02 선례).
 */
export default function InboundWorkSearch() {
  // 모듈 상태(조회 조건·모달 대상)는 첫 렌더 전에 비운다 — 탭을 다시 열면 빈 화면에서 시작한다.
  const initialized = useRef(false)
  if (!initialized.current) {
    initialized.current = true
    resetInboundWorkSearchStore()
  }
  const media = useMediaState()
  return (
    <>
      <InboundWorkSearchPage />
      <MediaModal
        menuCode={INBOUND_WORK_SEARCH_MENU_CODE}
        open={Boolean(media.target)}
        kind={media.target?.kind ?? null}
        row={media.target?.row ?? null}
        shipper={media.target?.shipper ?? ''}
        filesByFileId={media.filesByFileId}
        readOnly
        onClose={closeMedia}
      />
    </>
  )
}
